<template>
  <div class="palestra">
    <div class="foto">
      <b-img
        :src="`${baseUrl}${palestra.photo}`"
        fluid
        class="d-inline-block imagem"
        alt="imagem do palestrante"
      />
    </div>
    <div class="conteudo">
      <div class="informacoes">
        <div class="titulo">{{ palestra.title }}</div>
      </div>
      <div class="nome">{{ palestra.speaker.name }}</div>
    </div>
    <div class="painel">
      <div class="horario">
        Horário:
        {{ `${palestra.hour.split(":")[0]}:${palestra.hour.split(":")[1]}` }}
      </div>
      <div class="buttons">
        <b-button class="btnEditar" @click="onClickEditar(palestra._id)"
          >Editar Informações</b-button
        >

        <b-button class="btnInscritos" @click="verInscritos(palestra._id)"
          >Ver Inscritos</b-button
        >

        <b-button
          @click="onClickExcluir(palestra)"
          pill
          variant="outline-danger"
          class="btnExcluir"
          >Excluir</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { baseUrl } from "@/config/constants";

export default {
  components: {},
  data() {
    return {
      palestraSelecionada: "",
    };
  },
  methods: {
    verInscritos(idPalestra) {
      this.$router.push(`/admin/inscritos/${idPalestra}`);
    },
    onClickEditar(idPalestra) {
      this.$router.push(`/admin/editar-palestra/${idPalestra}`);
    },
    onClickExcluir(palestra) {
      this.$emit("excluir", palestra);
    },
  },
  computed: {
    imagem() {
      return {
        background: `url(${this.$props.palestra.speaker.photo}) no-repeat center center`,
      };
    },
    baseUrl() {
      return baseUrl;
    },
  },
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
    palestra: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
button {
  margin: 10px;
}
.btnEditar {
  background-image: linear-gradient(to right, #fbb03b, #ed1c24, #ff0000);
  border-radius: 35px;
  width: 180px !important;
  height: 38px !important;
  border: none;
  background-size: none;
}

.btnEditar:hover {
  background-position: 100% 0;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.btnInscritos {
  background-image: linear-gradient(to right, #fbb03b, #ed1c24, #ff0000);
  border-radius: 35px;
  width: 150px !important;
  height: 38px !important;
  border: none;
  background-size: none;
}

.btnInscritos:hover {
  background-position: 100% 0;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.btnExcluir {
  border-radius: 35px;
  color: black;
  width: 100px;
  height: 38px;
  background-size: 300% 100%;
}

.btn-light {
  color: #7e7e7e;
}

.btn-light:hover {
  color: #f0f0f0;
  background-color: #7e7e7e;
}

.nome {
  font-size: 1.4rem !important;
}
.foto {
  height: 8rem !important;
  width: 8rem !important;
  padding: 20px !important;
}
.titulo {
  font-size: 1.5rem !important;
}
.conteudo {
  padding-top: 18px !important;
}
.painel {
  padding: 20px !important;
}
.horario {
  font-weight: 500;
  font-size: 1rem !important;
  margin-right: 20px;
  margin-bottom: 10px;
  text-align: right;
}
.buttons {
  display: flex;
  flex-direction: row;
}

.palestra {
  width: 80%;
  height: auto;
  border: 1px solid #ee3824;
  border-radius: 30px;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  .foto {
    padding: 20px;
    height: 10rem;
    width: 10rem;
    .imagem {
      border-radius: 10px;
    }
  }
  .conteudo {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 4;
    padding-top: 30px;
    padding-bottom: 30px;
    .informacoes {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .titulo {
        font-size: 2rem;
        font-weight: 600;
      }
      .estado {
        color: #ff1601;
        font-size: 1.5rem;
        img {
          width: 20px;
          height: auto;
          margin-left: 5px;
          animation: neon 1s alternate infinite ease-in-out;
          --cor-neon: #ff1601;
        }
      }
    }
    .nome {
      font-size: 2rem;
      font-weight: 200;
      text-align: left !important;
    }
    .resumo {
      font-size: 1rem;
      font-weight: 400;
      text-align: justify;
    }
  }
  .painel {
    height: 100%;
    display: flex;
    flex: 1;
    padding: 20px;
    flex-direction: column;
    justify-content: space-between;
  }
}

@keyframes neon {
  from {
    filter: drop-shadow(0 0 0 var(--cor-neon));
  }

  to {
    filter: drop-shadow(0 0 2px var(--cor-neon));
  }
}
</style>
